import React from 'react';
import styled from 'styled-components';

import { primaryColor, errorColor } from '~theme';
import InfoTooltip from '~components/InfoTooltip';

const FormLabel = props => (
  <Label {...props} required={props.required}>
    {props.children}
    {props.disclaimer && <Disclaimer>{` ${props.disclaimer}`}</Disclaimer>}
    {props.required ? '\u00A0*' : ''}
    {props.info && (
      <InfoContainer>
        <InfoTooltip content={props.info} size="16px" />
      </InfoContainer>
    )}
  </Label>
);

const Label = styled.label`
  width: ${props => props.width || 'auto'};

  color: ${primaryColor};
  font-weight: 400;
  font-size: 16px;

  // padding-left: 5px;

  display: block;
  margin-bottom: ${props => (props.noMargin ? '0' : '8px')};

  // height: 16px;
  position: relative;
  /* ${props => props.required && 'font-weight: 700'}; */

  // NOTE Use this if you need a red asterisk!
  // &:after {
  //   font-weight: normal;
  //   content: ${props => (props.required ? '"*"' : '""')};
  //   // color: red;
  //   position: absolute;
  //   margin-left: 3px;
  //   top: 1px;
  //   right: -12px;
  //   font-size: 16px;
  // }
`;

const Disclaimer = styled.span`
  color: ${errorColor};
`;

const InfoContainer = styled.span`
  margin-left: 8px;

  & > * {
    // cursor: help;
  }
`;

export default FormLabel;
